import { confirmable } from "react-confirm";

import { Button, Icon } from "semantic-ui-react";

import { AccessibleModal } from "simplydo/react/components/Accessibility/AccessibleModal";

type ConfirmModalProps = {
  show?: boolean;
  proceed?: () => void;
  dismiss?: () => void;
  cancel?: () => void;
  title: string;
  confirmation: string;
};

const ConfirmModal = ({
  show,
  proceed,
  dismiss,
  cancel,
  title,
  confirmation,
}: ConfirmModalProps) => {
  return (
    <AccessibleModal
      mountNode={document.getElementById("semantic-modal-mount-node")}
      open={!!show}
      onClose={dismiss ?? (() => {})}
      basic
      size="small"
      className="no-scroll"
    >
      <AccessibleModal.Header content={title} />
      <AccessibleModal.Content>{confirmation}</AccessibleModal.Content>
      <AccessibleModal.Actions>
        <Button basic inverted onClick={cancel ?? (() => {})}>
          <Icon name="remove" /> Cancel
        </Button>
        <Button primary onClick={proceed ?? (() => {})}>
          <Icon name="checkmark" /> Confirm
        </Button>
      </AccessibleModal.Actions>
    </AccessibleModal>
  );
};

export default confirmable(ConfirmModal);
